(function () {
    'use strict';

    a3_cabin_reports.factory('CrewHotelFactory', CrewHotelFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CrewHotelFactory
    * @description 
    * Get hotels
    * @ngInject
    */
    function CrewHotelFactory(GenericService, $http, apiUrl) {

        var objType = 'crewHotel';
        var objCallback = CrewHotel;

        var service = {
            getCrewHotelsFromStorage: getCrewHotelsFromStorage,
            setCrewHotelsToStorage: setCrewHotelsToStorage,
            getCrewHotelFromStorage: getCrewHotelFromStorage          
        };

        /**
        * Initialize the CrewHotel
        * @memberof CrewHotelFactory
        */
        function CrewHotel() {
            this.AimsId = null;
            this.CrewName = null;
            this.DutyDate = null;
            this.Base = null;
            this.Airport = null;
            this.HotelNo = null;
            this.HotelName = null;
            this.GroundTime = null;
        }

        /**
         * Get Crew Hotels
         * @memberof CrewHotelFactory
         * @returns {Array} CrewHotels 
         */
        function getCrewHotelsFromStorage() {
            return GenericService.list(objType, objCallback);
        }

        /**
         * Save Crew Hotels to storage
         * @memberof GroundDutyFactory
         * @param {Array} objList A list of Crew Hotels
         */
        function setCrewHotelsToStorage(objList) {
            GenericService.saveAll(objList, objType);
        }

        /**
        * Get a specific Hotel
        * @memberof CrewHotelFactory
        * @returns {object} CrewHotel
        */
        function getCrewHotelFromStorage( dutydate ) {
            var crewHotels = getCrewHotelsFromStorage();
            if (crewHotels == null)
                return [];
            var arrayLength = crewHotels.length;
            for (var i = 0; i < arrayLength; i++) {
                if (crewHotels[i].Dutydate == dutydate) {
                    return crewHotels[i];
                }
            }
        }



        return service;
    }

})();